import { render } from "./studioCourseInfo.vue?vue&type=template&id=16d520aa&scoped=true"
import script from "./studioCourseInfo.vue?vue&type=script&lang=js"
export * from "./studioCourseInfo.vue?vue&type=script&lang=js"

import "./studioCourseInfo.vue?vue&type=style&index=0&id=16d520aa&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d520aa"]])

export default __exports__